<template>
  <div>
    <div class="row align-items-center justify-content-center">
      <div class="col-3">
        <img src="@/assets/agh.jpg" width="100%" class="text-center">
      </div>
    </div>
    <div style="margin-bottom: 32px;">
      <h2 class="text-center">Nieoficjalny kalkulator rekrutacyjny AGH 2022</h2>
    </div>
    <hr/>

    <div class="row align-items-center justify-content-center">
      <div class="col-lg-3 col-md-1" style="margin-top: 8px;">
        <select class="form-select" v-model="year" @change="load">
          <option value="2022">Rekrutacja 2022/2023</option>
          <option value="2021">Rekrutacja 2021/2022</option>
        </select>
      </div>
      <div class="col-lg-2 col-md-1" style="margin-top: 8px;">
        <select class="form-select" aria-label="Default select example" v-model="result.name" @change="onSubjectChange">
          <option v-for="subject in subjects" :key="subject" :value="subject">{{ subject }}</option>
        </select>
      </div>
      <div class="col-lg-2 col-md-1" style="margin-top: 8px;">
        <select class="form-select" aria-label="Poziom" v-model="result.level">
          <option value="basic" v-if="isBasicAvailable">Podstawowy</option>
          <option value="advanced">Rozszerzony</option>
          <option value="dual" v-if="result.name === 'Język obcy'">Dwujęzyczny</option>
        </select>
      </div>
      <div class="col-lg-3 col-md-1" style="margin-top: 8px;">
        <input type="number" min="0" max="100" class="form-control" pattern="^\d+$" inputmode="numeric"
               @change="validatePercentage"
               v-on:keyup.enter="save"
               v-model.number="result.value"
               placeholder="Wynik w punktach procentowych">
      </div>
      <div class="col-lg-1 col-md-1" style="margin-top: 8px;">
        <button class="btn btn-success btn-block" @click="save">Zapisz</button>
      </div>
    </div>

    <hr/>


    <table class="table table-bordered">
      <thead>
      <tr>
        <th scope="col">Przedmiot</th>
        <th scope="col">Poziom</th>
        <th scope="col">Wartość w %</th>
        <th scope="col">Brać pod uwagę?</th>
        <th scope="col">Opcje</th>
      </tr>
      </thead>
      <tbody>

      <tr v-for="entry in results" :v-key="entry.name + entry.level">
        <td>{{ entry.name }}</td>
        <td>{{ entry.level === 'basic' ? 'Podstawowy' : (entry.level === 'dual' ? 'Dwujęzyczny' : 'Rozszerzony') }}</td>
        <td>{{ entry.value }}%</td>
        <td>
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" :id="'enabled'+entry.name+entry.level"
                   v-model="entry.enabled">
            <label class="form-check-label" :for="'enabled'+entry.name+entry.level"></label></div>
        </td>
        <td>
          <a href="#" style="color: orange; margin-right: 8px;" @click="edit(entry)">Edytuj</a>
          <a href="#" style="color: red;" @click="remove(entry)">Usuń</a>
        </td>
      </tr>

      </tbody>
    </table>

    <hr/>

    <p>
      Aby wyliczyć wskaźnik rekrutacyjny W, <b>dodaj swoje wyniki maturalne za pomocą formularza wyżej</b> ⬆️ <br/>
      Dla każdego kierunku zostanie wyświetlona wartość wskaźnika W. <br/> Kalkulator symuluje branie różnych
      przedmiotów jako G1 oraz G2 oraz <b>wybiera tę konfigurację, która daje najwięcej punktów.</b>
    </p>

    <hr/>

    <table class="table table-bordered">
      <thead>
      <tr>
        <th scope="col">L.p</th>
        <th scope="col">Kierunek</th>
        <th scope="col">Wynik (maksymalnie 1000)</th>
        <th scope="col">Progi 2021</th>
        <th scope="col">G1</th>
        <th scope="col">G2</th>
      </tr>
      </thead>
      <tbody>

      <tr v-for="target in targets" :v-key="target.name">
        <td>{{ target.id }}</td>
        <td v-bind:style="{ color: getColor(target, calcTotal(target))}">{{ target.name }}</td>
        <td>
          {{ calcTotal(target) }}
          <span v-tooltip="calcTotal(target, 'tooltip')" v-if="calcTotal(target)>0">ℹ️</span>
        </td>
        <td style="min-width: 130px;" v-tooltip="constructThresholdMessage(target)">
          <span>{{ constructThreshold(target) }}</span>
        </td>
        <td v-html="fillG(target.g1, calcTotal(target, 'g1'), calcTotal(target, 'g1-points'))"></td>
        <td v-html="fillG(target.g2, calcTotal(target, 'g2'), calcTotal(target, 'g2-points'))"></td>
      </tr>

      </tbody>
    </table>

    <hr/>
    <div style="text-align: center">
      <form action="https://www.paypal.com/donate" method="post" target="_top">
        <input type="hidden" name="hosted_button_id" value="GVQ7NKSTNSADC"/>
        <input type="image" src="https://www.paypalobjects.com/pl_PL/PL/i/btn/btn_donate_LG.gif" border="0"
               name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button"/>
        <img alt="" border="0" src="https://www.paypal.com/pl_PL/i/scr/pixel.gif" width="1" height="1"/>
      </form>

      <p>
        Strona została wykonana przez <a href="https://github.com/matisiekpl">Mateusza Woźniaka</a> (<a
          href="mailto:matisiek11@gmail.com">kontakt</a>). Technologia: Vue.
        Data
        aktualizacji: 10.05.2022 r.<br/>
        <a target="_blank"
           href="https://rekrutacja.agh.edu.pl/warunki-rekrutacji/">https://rekrutacja.agh.edu.pl/warunki-rekrutacji/</a>
      </p>
    </div>
  </div>
</template>

<script>
import targets2021 from './../assets/targets_2021.json';
import targets2022 from './../assets/targets_2022.json';
import points from './../assets/points.json';

export default {
  data() {
    return {
      results: [],
      year: '2022',
      result: {
        name: 'Matematyka',
        level: 'basic',
        value: null,
        enabled: true,
      },
      isBasicAvailable: true,
      targets: [],
      advancedSubjects: ['Informatyka', 'Fizyka', 'Chemia', 'Biologia', 'Filozofia', 'Geografia', 'Historia', 'Historia sztuki', 'Wiedza o społeczeństwie'],
      subjects: ['Matematyka', 'Informatyka', 'Fizyka', 'Chemia', 'Biologia', 'Filozofia', 'Geografia', 'Historia', 'Historia sztuki', 'Wiedza o społeczeństwie', 'Język polski', 'Język obcy']
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.targets = this.year === '2022' ? targets2022 : targets2021;
      this.$forceUpdate();
    },
    validatePercentage(e) {
      const self = this;
      if (self.result.value > 100) self.result.value = 100;
      if (self.result.value < 0) self.result.value = 0;
    },
    save() {
      const self = this;
      self.result.value = parseInt(self.result.value);
      if (Number.isInteger(self.result.value)) {
        if (self.results.some(x => x.name === self.result.name && x.level === self.result.level)) {
          const entry = self.results.find(x => x.name === self.result.name && x.level === self.result.level);
          const index = self.results.indexOf(entry);
          entry.value = self.result.value;
          self.results[index] = entry;
        } else
          self.results.push(JSON.parse(JSON.stringify(self.result)));
      }
    },
    edit(entry) {
      this.result = JSON.parse(JSON.stringify(entry));
    },
    remove(entry) {
      this.results.splice(this.results.indexOf(entry), 1);
    },
    onSubjectChange() {
      const self = this;
      if (self.advancedSubjects.includes(self.result.name)) {
        self.isBasicAvailable = false;
        self.result.level = 'advanced';
        self.$forceUpdate();
      } else {
        self.isBasicAvailable = true;
        self.result.level = 'basic';
      }
    },
    calcTotal(target, out) {
      const self = this;
      const basicMath = self.taken.find(x => x.name === 'Matematyka' && x.level === 'basic');
      let m = 0;
      if (basicMath != null) {
        m = 2 * basicMath.value;
      }

      let gOptions = [];
      for (const entry of self.taken) {
        let basic = self.taken.find(x => x.name === entry.name && x.level === 'basic');
        let advanced = self.taken.find(x => x.name === entry.name && x.level === 'advanced');
        let dual = self.taken.find(x => x.name === entry.name && x.level === 'dual');
        basic = basic != null ? basic.value : 0;
        advanced = advanced != null ? advanced.value : 0;
        dual = dual != null ? dual.value : 0;
        const g = self.calcG(basic, advanced, entry.name, dual);
        gOptions.push({
          name: entry.name,
          value: g,
        });
      }
      gOptions = gOptions.sort((a, b) => a.value < b.value ? 1 : -1);

      const g1 = gOptions.filter(x => target.g1.includes(x.name.toString().toLowerCase()))[0];
      const g2 = gOptions.filter(x => target.g2.includes(x.name.toString().toLowerCase()))[0];
      const g1Name = (g1 != null) ? g1.name : '';
      const g2Name = (g2 != null) ? g2.name : '';
      const g1Value = (g1 != null) ? g1.value : 0;
      const g2Value = (g2 != null) ? g2.value : 0;

      const w = m + 3 * g1Value + g2Value;
      if (out == null) return w;
      if (out === 'tooltip') {
        let d = '';
        d += 'M = 2 * ' + (m / 2) + '<br/>';
        d += 'G1 = ' + g1Value + '<br/>';
        d += 'G2 = ' + g2Value + '<br/><br/>';
        d += "W = 2 * " + (m / 2) + " + 3 * " + g1Value + " + " + g2Value;
        return d;
      }
      if (out === 'g1') return g1Value > 0 ? g1Name : '';
      if (out === 'g2') return g2Value > 0 ? g2Name : '';
      if (out === 'g1-points') return g1Value;
      if (out === 'g2-points') return g2Value;
    },
    calcG(basicValue, advancedValue, subject, dualValue) {
      if (subject === 'Język obcy' && dualValue > 0) {
        if (dualValue < 30) return basicValue + dualValue;
        if (dualValue <= 50) return dualValue + 100;
        return 200;
      }
      if (advancedValue === 0 && subject !== 'Matematyka') return basicValue;
      if (basicValue !== 0 && advancedValue !== 0 && subject !== 'Matematyka') return basicValue + advancedValue;
      if (advancedValue > 80) return advancedValue + 100;
      if (advancedValue >= 30) return advancedValue + 2 * (advancedValue - 30);
      if (subject !== 'Matematyka') return advancedValue;
      return 0;
    },
    fillG(subjects, subject, points) {
      subject = subject.toString().toLowerCase();
      if (subject.length > 0)
        return subjects.replaceAll(subject, '<span style="font-weight: bold;">' + subject + " (" + points + ")</\span>"); else return subjects;
    },
    getColor(target, w) {
      const row = points.find(x => x.target === target.name);
      if (row == null) return 1001;
      if (row['2022_max_a'] < 300 || row['2022_min_a'] < 300) return 'black';
      if (row['2022_max_a'] === 1000) return w >= row['2022_min_a'] ? 'green' : 'black';
      if (w >= row['2022_max_a']) return 'green';
      return w >= row['2022_min_a'] ? 'orange' : 'black';
    },
    constructThreshold(target) {
      const row = points.find(x => x.target === target.name);
      if (row == null) return '-';
      const suffix = row['2022_accuracy'] === 'high' ? ' (potwierdzone)' : '';
      if (row['2022_max_a'] === 1000) return row['2022_min_a'] + suffix;
      return 'od ' + row['2022_min_a'] + ' do ' + row['2022_max_a'] + suffix;
    },
    constructThresholdMessage(target) {
      const row = points.find(x => x.target === target.name);
      if (row == null) return 'brak danych';
      let o = '';
      o += 'Progi 2021:<br\>';
      o += `1 cykl: ${row['2022_min_a']} - ${row['2022_max_a']} ${row['2022_accuracy'] === 'high' ? ' (pewne)' : ''}<br\>`;
      o += `2 cykl: ${row['2022_min_b']} - ${row['2022_max_b']} ${row['2022_accuracy'] === 'high' ? ' (pewne)' : ''}<br\>`;
      o += `3 cykl: ${row['2022_min_c']} - ${row['2022_max_c']} ${row['2022_accuracy'] === 'high' ? ' (pewne)' : ''}<br\>`;
      o += 'Progi 2020:<br\>';
      o += `1 cykl: ${row['2021_min_a']} - ${row['2021_max_a']} ${row['2021_accuracy'] === 'high' ? ' (pewne)' : ''}<br\>`;
      o += `2 cykl: ${row['2021_min_b']} - ${row['2021_max_b']} ${row['2021_accuracy'] === 'high' ? ' (pewne)' : ''}<br\>`;
      o += `3 cykl: ${row['2021_min_c']} - ${row['2021_max_c']} ${row['2021_accuracy'] === 'high' ? ' (pewne)' : ''}<br\>`;
      o += 'Progi 2019:<br\>';
      o += `1 cykl: ${row['2020_min_a']} - ${row['2020_max_a']} ${row['2020_accuracy'] === 'high' ? ' (pewne)' : ''}<br\>`;
      o += `2 cykl: ${row['2020_min_b']} - ${row['2020_max_b']} ${row['2020_accuracy'] === 'high' ? ' (pewne)' : ''}<br\>`;
      o += 'Progi 2018:<br\>';
      o += `1 cykl: ${row['2019_min_a']} - ${row['2019_max_a']} ${row['2019_accuracy'] === 'high' ? ' (pewne)' : ''}<br\>`;
      return o;
    }
  },
  computed: {
    taken() {
      return this.results.filter(x => x.enabled);
    }
  }
}
</script>

<style>
@media only screen and (max-width: 600px) {
  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}
</style>
